/**
 * Shared UI utilities.
 *
 * `cn` merges Tailwind class strings with conflict resolution — the
 * canonical shadcn pattern. Keep this file framework-agnostic so it
 * can be re-exported from packages later if/when chaos-ui grows.
 */
import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
